import {createContext, SetStateAction, useContext} from "react";

export interface KeHoachContextProps {
  dsYeuCau: any;
  setDsYeuCau: SetStateAction<any>;
  detailPhieuYeuCau: any;
  setDetailPhieuYeuCau: SetStateAction<any>;

}

const initialContext = {
  dsYeuCau: [],
  setDsYeuCau: () => { },
  detailPhieuYeuCau: [],
  setDetailPhieuYeuCau: () => { },
}

export const KeHoachContext = createContext<KeHoachContextProps>(initialContext);

export const useKeHoachContext = () => useContext(KeHoachContext);

export const KeHoachProvider = KeHoachContext.Provider;
